import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import VoiceLead from "../VoiceLead";
import VoiceIntroImage from "../VoiceIntroImage";
import getGridHeight from "@src/utils/getGridHeight";
import settings from "@src/settings";
import { between, down, only, up } from "styled-breakpoints";
import { Lead } from "@src/components/VoiceLead/styles";
import trimLeading from "@src/utils/trimLeading";
import getGridWidth from "@src/utils/getGridWidth";

const { fontSize, lineGap } = settings.voiceGrid;

export const Frame = styled.div``;

export const Container = styled.div<{ windowW: number | null }>`
	margin: auto;
	font-size: 16px;
	line-height: 2;
	padding: ${getGridHeight({ rows: 5, withBottomGap: true })}px 0;
	${up("lg")} {
		width: ${settings.contentWidth.lg}px;
	}
	${only("md")} {
		padding: ${getGridHeight({ rows: 3, withBottomGap: true })}px 0;
		width: ${settings.contentWidth.md}px;
	}
	${only("sm")} {
		padding: ${getGridHeight({ rows: 2, withBottomGap: true })}px 0;
		width: ${settings.contentWidth.sm}px;
	}
	${down("xs")} {
		padding: ${getGridHeight({ rows: 1, withBottomGap: true })}px 0
			${getGridHeight({ rows: 2, withBottomGap: true })}px;
		width: ${(props) =>
			getGridWidth({ windowW: props.windowW }) -
			settings.baseGrid.fontSize * 2}px;
	}
`;

export const Intro = styled.div`
	display: flex;
	margin-bottom: ${getGridHeight({
		rows: 2,
		withTopGap: true,
		withBottomGap: true,
	})}px;
	& > ${VoiceIntroImage} {
		flex: 1 1 50%;
	}
	${up("lg")} {
		height: ${getGridHeight({ rows: 12 })}px;
		& > * + * {
			margin-left: 2rem;
		}
	}
	${down("md")} {
		flex-direction: column-reverse;
		& > * + * {
			margin-bottom: ${getGridHeight({
				rows: 1,
				withBottomGap: true,
				withTopGap: true,
			})}px;
		}
		& > ${VoiceIntroImage} {
			width: 100%;
		}
	}
	${between("sm", "md")} {
		& > ${VoiceIntroImage} {
			flex: 0 0 ${getGridHeight({ rows: 14 })}px;
			height: ${getGridHeight({ rows: 14 })}px;
		}
	}
	${down("xs")} {
		& > ${VoiceIntroImage} {
			flex: 0 0 ${getGridHeight({ rows: 10 })}px;
			height: ${getGridHeight({ rows: 10 })}px;
		}
	}
`;

export const IntroText = styled.div`
	position: relative;
	height: 100%;
	flex: 1 1 50%;
	& > ${VoiceLead} {
		flex-grow: 1;
		height: 100%;
		padding-bottom: 60px;
	}
`;

export const NextIntro = styled.div`
	background-color: ${settings.color.pale};
	padding: ${getGridHeight({
			rows: 3,
			withTopGap: true,
		})}px
		0;
	${down("xs")} {
		padding: ${getGridHeight({
				rows: 2,
				withTopGap: true,
			})}px
			0;
	}
`;

export const NextIntroItem = styled.a<{ windowW: number | null }>`
	display: flex;
	padding: ${getGridHeight({ rows: 2, withBottomGap: true })}px 3rem;
	background-color: #fff;
	border-radius: 14px;
	margin: auto;
	position: relative;
	cursor: pointer;
	& > ${VoiceLead}, & > ${VoiceIntroImage} {
		flex: 1 1 50%;
	}
	&:after {
		content: "";
		display: block;
		width: 0;
		height: 0;
		border-color: transparent;
		border-left-color: #fff;
		border-width: 13px 0 13px 23px;
		border-style: solid;
		position: absolute;
		top: 50%;
		right: 0;
		transform: translate(100%, -50%);
	}
	${Lead} {
		${trimLeading({
			fontSize: settings.baseGrid.fontSize * (8 / 7),
			lineHeight: 36,
		})}
		padding-bottom: ${getGridHeight({ rows: 1 })}px;
	}
	${up("lg")} {
		width: ${settings.contentWidth.lg}px;
		height: ${getGridHeight({ rows: 15 })}px;
	}
	${only("md")} {
		width: ${settings.contentWidth.md}px;
	}
	${only("sm")} {
		width: ${settings.contentWidth.sm}px;
	}
	${down("md")} {
		flex-direction: column-reverse;
		height: auto;
		& > ${VoiceLead} {
			flex: 1 1 auto;
		}
		& > ${VoiceIntroImage} {
			flex: 0 0 ${getGridHeight({ rows: 12 })}px;
			height: ${getGridHeight({ rows: 12 })}px;
			margin-bottom: ${getGridHeight({
				rows: 1,
				withBottomGap: true,
				withTopGap: true,
			})}px;
		}
	}
	${down("xs")} {
		width: ${(props) =>
			getGridWidth({ windowW: props.windowW }) -
			settings.baseGrid.fontSize * 2}px;
		&:after {
			content: "";
			border-width: 11px 0 11px 17px;
		}
		padding: ${getGridHeight({ rows: 1, withBottomGap: true })}px 2rem
			${getGridHeight({ rows: 2, withBottomGap: true })}px;
		& > ${VoiceIntroImage} {
			flex: 0 0 ${getGridHeight({ rows: 6 })}px;
		}
	}
`;
